<template>
  <v-container fluid class="pb-0">
    <div
      v-if="!loanApplication || !initialLoadDone"
      class="d-flex flex-row pb-3"
    >
      <span class="text-h5">Loading</span>
      <v-spacer></v-spacer>
      <div class="text-center" style="width: 65.81px">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <div v-if="loanApplication && initialLoadDone">
      <v-row no-gutters>
        <div class="d-flex flex-column">
          <div>
            <span
              class="text-h5"
              style="border-bottom: 2px solid #4caf50; line-height: 1.5rem"
              >NOTES</span
            >
          </div>
          <div>
            <span>Loan Application by</span>
            <span style="color: #4caf50; font-weight: bold">
              {{ loanApplication.employee.name }}
              {{ loanApplication.employee.surname }}
            </span>
            <span>on {{ loanApplication.createdAt }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!loading"
          depressed
          min-width="65.81"
          class="pa-0 mr-auto mb-2"
          color="green"
          dark
          @click="addNote()"
        >
          <v-icon> mdi-plus </v-icon>
        </v-btn>
        <div v-if="loanApplication.notes" class="ml-auto">
          <v-btn
            v-if="unsavedChanges"
            depressed
            min-width="65.81"
            class="pa-0 ml-3 mb-2"
            color="green"
            :dark="!loading"
            :disabled="loading"
            :loading="loading"
            @click="updateNotes()"
            >Save</v-btn
          >
        </div>
      </v-row>
      <div v-if="loanApplication.notes">
        <v-row no-gutters v-if="loanApplication.notes.length > 0">
          <v-card
            v-for="(note, i) in loanApplication.notes"
            :key="i"
            width="100%"
            outlined
            class="my-2 px-2"
          >
            <v-row no-gutters class="pt-2">
              <div :style="'width:' + noteNameWidth">
                <v-text-field
                  v-model="loanApplication.notes[i].noteName"
                  label="Name:"
                  readonly
                  type="string"
                ></v-text-field>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                v-if="loanApplication.notes[i].noteName === userEmail"
                depressed
                icon
                min-width="0"
                color="red"
                dark
                style="align-self: center"
                @click="deleteNote(note)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-row>
            <v-row no-gutters>
              <v-textarea
                :name="'inputNoteContent' + i"
                v-model="loanApplication.notes[i].noteContent"
                v-on:input="unsavedChanges = true"
                :readonly="!loanApplication.notes[i].newNote"
                class="pt-0"
                auto-grow
                rows="1"
                label="Note:"
                type="string"
              ></v-textarea>
            </v-row>
            <v-row no-gutters style="margin-bottom: 6px; margin-top: -13px">
              <span style="color: #4caf50; font-weight: bold">Created:</span>
              <span style="margin-left: 4px">
                {{ loanApplication.notes[i].createdAt }}</span
              >
            </v-row>
          </v-card>
        </v-row>
      </div>
      <div class="text-center">
        <v-dialog
          v-model="confirmNoteDeleteDialog"
          :width="confirmNoteDeleteDialogSize"
          persistent
          overlay-opacity="0.7"
        >
          <v-card color="red lighten-1"
            ><v-card-text
              class="pa-2 pb-0 text-center text-body-1"
              style="color: white"
            >
              Are you sure you want to delete this note?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="white" @click="cancelNoteDelete">
                Cancel
              </v-btn>
              <v-btn depressed dark color="green" @click="completeNoteDelete">
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-container>
</template>

<script>
import { LoanApplication } from "@/models";
import { DataStore } from "aws-amplify";
import { Auth } from "aws-amplify";
import _ from "lodash";

export default {
  name: "ApplicationNotes",

  props: {
    application: {},
  },
  components: {},
  data: () => ({
    loanApplication: null,
    // loanApplicationCreatedAt: "",
    valid: false,
    loading: true,
    noteToDelete: {},
    unsavedChanges: false,
    initialLoadDone: false,
    queriedLoanApplication: null,
    confirmNoteDeleteDialog: false,
    userEmail: "",
  }),

  async mounted() {
    try {
      await this.getApplication();
      const userData = await Auth.currentUserInfo().catch((err) => {
        console.log("Error getting user: ", err);
      });
      if (userData) {
        this.userEmail = userData.attributes.email;
      }
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    async getApplication() {
      try {
        const applicationId = this.application.id;
        this.subscription = DataStore.observeQuery(LoanApplication, (l) =>
          l.id("eq", applicationId)
        ).subscribe(async (snapshot) => {
          const { items, isSynced } = snapshot;
          if (isSynced && items.length > 0) {
            this.queriedLoanApplication = items[0];
            if (!this.initialLoadDone) {
              // if (items[0].notes !== null) {
              this.loanApplication = _.cloneDeep(items[0]);
              if (this.loanApplication.notes === null) {
                this.loanApplication.notes = [];
              }
              // }
              // else {
              //   this.loanApplication.notes = [];
              // }
              this.loanApplication.createdAt = items[0].createdAt
                .split(".")[0]
                .replace("T", " ");
              this.loading = false;
              this.initialLoadDone = true;
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteNote(item) {
      try {
        this.noteToDelete = item;
        this.confirmNoteDeleteDialog = true;
      } catch (error) {
        console.log(error);
      }
    },
    completeNoteDelete() {
      let noteIndex = this.loanApplication.notes.indexOf(this.noteToDelete);
      if (noteIndex !== -1) {
        // console.log("Deleting note: ", this.noteToDelete);
        // console.log("Notes: ", this.loanApplication.notes);
        this.loanApplication.notes.splice(noteIndex, 1);
      }
      this.confirmNoteDeleteDialog = false;
      this.updateNotes();
    },
    cancelNoteDelete() {
      this.noteToDelete = {};
      this.confirmNoteDeleteDialog = false;
    },

    addNote() {
      try {
        // console.log("this.loanApplication.notes", this.loanApplication.notes);
        this.loanApplication.notes.push({
          noteName: this.userEmail,
          noteContent: "",
          createdAt: new Date().toISOString().split(".")[0].replace("T", " "),
          newNote: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async updateNotes() {
      try {
        this.loading = true;
        const notesWithContent = this.loanApplication.notes.filter(
          (element) => {
            return element.noteContent !== "";
          }
        );
        // if (this.loanApplication.notes.length > 0) {
        for (const i in notesWithContent) {
          if (notesWithContent[i].newNote) {
            // console.log(this.loanApplication.notes[i]);
            delete notesWithContent[i].newNote;
          }
        }
        await DataStore.save(
          LoanApplication.copyOf(
            this.queriedLoanApplication,
            (updateApplication) => {
              updateApplication.notes = notesWithContent;
            }
          )
        );
        this.unsavedChanges = false;
        this.loading = false;
        // } else {
        //   await DataStore.save(
        //     LoanApplication.copyOf(
        //       this.queriedLoanApplication,
        //       (updateApplication) => {
        //         updateApplication.notes = [];
        //       }
        //     )
        //   );
        // this.unsavedChanges = false;
        // this.loading = false;
        // }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    noteNameWidth() {
      var size = String;
      if (this.$vuetify.breakpoint.xs) {
        size = "85%";
      } else if (this.$vuetify.breakpoint.sm) {
        size = "60%";
      } else if (this.$vuetify.breakpoint.md) {
        size = "40%";
      } else if (this.$vuetify.breakpoint.lg) {
        size = "30%";
      } else if (this.$vuetify.breakpoint.xl) {
        size = "10%";
      }
      return size;
    },
    confirmNoteDeleteDialogSize() {
      var size = String;
      if (this.$vuetify.breakpoint.xs) {
        size = "100vw";
      } else if (this.$vuetify.breakpoint.sm) {
        size = "400px";
      } else if (this.$vuetify.breakpoint.md) {
        size = "450px";
      } else if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
        size = "500px";
      }
      return size;
    },
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  },
};
</script>